import { Button, Table } from "antd";
import { useEffect, useState } from "react";
import TipoDocumentoModal from "./componente/TipoDocumentoModal";
import { apiCtrlDoc, apiDocumentos } from "../../../services/api";

const TipoDocumentoPage = () => {

    const [openModal, setOpenModal] = useState(false);
    const [dataTipoDocumento, setDataTipoDocumento] = useState([]);

    useEffect(() => {
        loadTipoDocumentos();
    }, []);

    const loadTipoDocumentos = async () => {
        setDataTipoDocumento(await apiCtrlDoc.get("/tipos-documentos").then(response => response.data));
    };

    const handleSave = async (values: any) => {
        await fetch("/tipo-documento", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(values),
        });

        setOpenModal(false);
        loadTipoDocumentos();
    };

    return (
        <div>
            <Button type="primary" onClick={() => setOpenModal(true)}>
                Novo Tipo Documento
            </Button>

            <TipoDocumentoModal
                open={openModal}
                onCancel={() => setOpenModal(false)}
                onSave={handleSave}
            />

            <Table
                dataSource={dataTipoDocumento}
                columns={[
                    { title: "ID", dataIndex: "idCtrlDocTpDoc" },
                    { title: "Nome", dataIndex: "nmTpDoc" },
                    { title: "Tem Dt Emissão?", dataIndex: "temDataEmissao", render: v => v ? "Sim" : "Não" },
                    { title: "Tem Número?", dataIndex: "temNumero", render: v => v ? "Sim" : "Não" },
                    {
                        title: "Ações",
                        render: row => (
                            <Button danger onClick={() => apiDocumentos.delete(`/tipo-documento/${row.id}`).then(loadTipoDocumentos)}>
                                Excluir
                            </Button>
                        )
                    }
                ]}
            />
        </div>
    );
}

export default TipoDocumentoPage;